import translations from './strontium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/strontium'

export const strontium: Metal = {
  id: 31,
  slug: 'strontium',
  name: t.name,
  symbol: 'Sr',
  // Coordinates geocoded from the sheet's place names; "Nouhu" matches no Chinese
  // settlement, so it sits on the Lishui celestite district instead.
  mines: [
    {
      name: 'Nouhu, strontium mine (China)',
      region: 'Nouhu',
      coordinates: [119.02, 31.65],
    },
    {
      name: 'Montevives, strontium mine (Spain)',
      region: 'Montevives',
      coordinates: [-3.68, 37.1],
    },
    {
      name: 'Saltillo, strontium mine (Mexico)',
      region: 'Saltillo',
      coordinates: [-100.97, 25.42],
    },
    {
      name: 'Bandar Abbas, strontium mine (Iran)',
      region: 'Bandar Abbas',
      coordinates: [56.28, 27.19],
    },
    {
      name: 'Otanmäki, strontium mine (Finland)',
      region: 'Otanmäki',
      coordinates: [27.12, 64.12],
    },
  ],
  countries: [
    { name: 'Iran', percent: 39.3 },
    { name: 'Spain', percent: 39.3 },
    { name: 'China', percent: 15.7 },
    { name: 'Mexico', percent: 4.9 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
